module.exports = __webpack_public_path__ + "static/media/december-img-new.7596ec18.jpg";